import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Preloader from './Preloader';
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as userDataActions from '../../actions/userDataActions';
import * as appDataActions from '../../actions/appDataActions';
import * as appConstants from '../../constants/appConstants';
import * as appHelper from '../../helpers/appHelper';
import * as navHelper from '../../helpers/navigationHelper';
import * as dataHelper from '../../helpers/dataHelper';
import * as enviromentHelper from '../../helpers/environmentHelper';
import {RESUME_CONFIG, LOCALE_CONFIG} from '../../models/dialogModels';
import * as shortHandModels from '../../models/shortHandModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class Initialisation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            initData: this.props.initData,
            contentData: this.props.contentData,
            dialogPopup: this.props.dialogPopup,
            contentLoadingStarted: false,
            trackingData: this.props.trackingData,
            trackingStarted: false,
            imagesReadyToPreload: false,
            imagesToLoad: [],
            loadedImages: [],
            checkInitialisation: false,
            env: enviromentHelper.getEnvironment(),
            checkSetInitialScreen: true,
            localisedStringsSet: false,
        };
        this.loadedImages = [];
        this.imagesLoaded = false;


        this.checkInitialised = this.checkInitialised.bind(this);
        this.getInitStateByContsant = this.getInitStateByContsant.bind(this);
        this.updateInitialisedState = this.updateInitialisedState.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onImageLoaded = this.onImageLoaded.bind(this);
        this.setInitialScreen = this.setInitialScreen.bind(this);
    }

    componentDidMount() {
        this.checkInitialised();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.initData.initialised || (this.state.initData !== nextProps.initData || this.state.contentData !== nextProps.contentData || this.state.trackingData !== nextProps.trackingData)) {
            this.setState({
                initData: nextProps.initData,
                contentData: nextProps.contentData,
                trackingData: nextProps.trackingData,
            });
            this.checkInitialised();
        }

        if (this.state.trackingData !== nextProps.trackingData && !nextProps.initData.initialised) {
            this.setState({
                trackingData: nextProps.trackingData,
                checkInitialisation: true
            });
        }

        if (this.state.dialogPopup !== nextProps.dialogPopup) {
            this.setState({
                dialogPopup: nextProps.dialogPopup,
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkInitialisation) {
            this.checkInitialised();
        }
    }

    checkInitialised() {
        this.setState({
            checkInitialisation: false
        });
        let initData = this.state.initData;
        if (!initData.initialised) {
            switch (initData.currentState) {
                case appConstants.INIT_STATE_DATA_LOADED:

                    if (!this.props.contentData.contentLoaded) {
                        this.props.actions.loadContentData(initData);
                    } else {

                        //let default_langauge = this.props.contentData.experience.default_langauge;
                        let default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages,"is_selected",true).language_code;

                        appHelper.setContentData();
                        this.props.actions.setProjectTitle(this.props.contentData.experience.locale[default_langauge].experience_title);
                        this.props.actions.setInitialUserData(this.props.contentData.experience);
                        this.setState({imagesToLoad: Object.assign([], appHelper.getImagesToPreload(default_langauge,this.props.contentData.experience.assets))});
                        this.updateInitialisedState(appConstants.INIT_STATE_DATA_LOADED);
                    }
                    break;
                case appConstants.INIT_STATE_IMAGES_PRE_LOADED:
                    if (!this.imagesLoaded) {
                        this.setState({imagesReadyToPreload: true});
                    } else {
                        this.updateInitialisedState(appConstants.INIT_STATE_IMAGES_PRE_LOADED);
                    }
                    break;
                case appConstants.INIT_STATE_TRACKING_READY:
                    if (!this.props.trackingData.initialised && !this.state.trackingStarted) {
                        this.setState({trackingStarted: true});
                        this.props.actions.initTracking(this.props.contentData,this.props.userData);
                    } else {
                        if(this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length > 1 && !this.props.initData.lang_preference_invoked && !this.props.initData.lang_suspend_data_set){
                            this.props.actions.updateUserDataWithSuspendData().then((userData) => {
                                let tempInitData = Object.assign({}, this.props.initData, {
                                    lang_suspend_data_set: true
                                });

                                this.props.actions.updateInitData(tempInitData);


                            }).catch(error => {
                                console.log(`initialisation suspend_data error`,error);
                            });
                        }else if(this.state.trackingData.initialised && Object.keys(this.props.contentData.experience.locale).length > 1 && !this.props.initData.lang_preference_invoked && this.props.initData.lang_suspend_data_set && !this.props.initData.lang_preference_set){
                            let default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages,"is_selected",true).language_code;
                            let title = this.props.contentData.experience.locale[default_langauge].experience_title;
                            let dialogConfig = Object.assign({}, LOCALE_CONFIG, {
                                title: title
                            });

                            let tempInitData = Object.assign({}, this.props.initData, {
                                lang_preference_invoked: true
                            });

                            this.props.actions.updateInitData(tempInitData);
                            this.props.actions.setNewDialog(dialogConfig);

                         }else if (this.state.trackingData.initialised &&  Object.keys(this.props.contentData.experience.locale).length > 1 && this.props.initData.lang_preference_set ) {
                            this.updateInitialisedState(appConstants.INIT_STATE_TRACKING_READY);
                        }else if (this.state.trackingData.initialised &&  Object.keys(this.props.contentData.experience.locale).length === 1 ) {
                            this.props.actions.updateUserDataWithSuspendData();
                            this.updateInitialisedState(appConstants.INIT_STATE_TRACKING_READY);
                        }
                    }
                    break;

                default:
                    break;
            }
        } else {
            if (this.state.checkSetInitialScreen) {
                this.setInitialScreen();
            }
        }
    }

    setInitialScreen() {
        //console.log(`setInitialScreen`);
        this.props.actions.removeDialog();
        let biteCount = this.props.contentData.experience.bites.length;

        if (parseInt(this.props.trackingData.lesson_location) === -1 || this.props.contentData.experience.lesson_location === -1) {
            let tempInitData = Object.assign({}, this.props.initData, {
                resumed: true
            });

            this.props.actions.updateInitData(tempInitData);
            let contentDataExperience = Object.assign({}, this.props.contentData.experience, {
                lesson_location: 0
            });

            let contentData = Object.assign({}, this.props.contentData, {
                experience: contentDataExperience
            });

            /* if(this.props.trackingData.lesson_location === -1 && this.props.contentData.experience.include_resume_dailog && appHelper.isDefined(this.props.trackingData.suspend_data[sh_bite])){
                 this.setState({checkSetInitialScreen: false});
                 this.props.actions.setNewDialog(RESUME_CONFIG);
             }else{*/


            this.props.actions.updateContentData(contentData);
            this.context.router.push(`/menu`);
            //}


        } else {
            let devBookMark = undefined;

            if (appHelper.isDefined(this.props.contentData.experience.lesson_location) && parseInt(this.props.contentData.experience.lesson_location) > 0) {
                devBookMark = appHelper.getBiteByScreenId(this.props.contentData.experience.lesson_location);
            }

            let bookmark = appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
            if (appHelper.isDefined(devBookMark) && this.props.trackingData.lesson_location === 0) {
                let tempInitData = Object.assign({}, this.props.initData, {
                    resumed: true
                });

                this.props.actions.updateInitData(tempInitData);
                let bookmark = appHelper.getBiteByScreenId(this.props.contentData.experience.lesson_location);
                //console.log(`bookmark goto ${bookmark} ${this.state.initData.initialised}`, this.props.trackingData);
                //console.log(`line 179`);
                this.props.actions.setLessonLocation(this.props.contentData.experience.lesson_location);
                this.context.router.push(`/${bookmark}`);

            } else if (appHelper.isDefined(bookmark) && !isNaN(this.props.trackingData.lesson_location)) {
                let sh_bite = appHelper.getShortHandKeyByRef("bites").key;

                if (this.props.contentData.experience.include_resume_dailog && appHelper.isDefined(this.props.trackingData.suspend_data[sh_bite]) && this.props.contentData.experience.tracking_type !== "open" && !this.state.initData.resumed) {
                    this.setState({checkSetInitialScreen: false});
                    let tempInitData = Object.assign({}, this.props.initData, {
                        resumed: true
                    });

                    this.props.actions.updateInitData(tempInitData);
                    this.props.actions.setNewDialog(RESUME_CONFIG);
                } else {
                    let tempInitData = Object.assign({}, this.props.initData, {
                        resumed: true
                    });

                    this.props.actions.updateInitData(tempInitData);
                    //console.log(`line 201`);
                    this.props.actions.setLessonLocation(this.props.trackingData.lesson_location);
                    this.context.router.push(`/${bookmark}`);
                }
            } else {
                let tempInitData = Object.assign({}, this.props.initData, {
                    resumed: true
                });

                this.props.actions.updateInitData(tempInitData);
                let bookmark = appHelper.getBiteByScreenId(this.props.contentData.experience.bites[0].screens[0].screen_id);
                //console.log(`line 211`);
                this.props.actions.setLessonLocation(this.props.contentData.experience.bites[0].screens[0].screen_id);
                this.context.router.push(`/${bookmark}`);
            }

        }

    }

    updateInitialisedState(constant) {
        let initData = Object.assign({}, this.props.initData);
        let default_langauge = appHelper.getArrayObjectByKey(this.props.contentData.experience.languages,"is_selected",true).language_code;

        let strings = this.props.contentData.experience.strings[default_langauge];
        let initStates = [];

        for(let i = 0; i < initData.initialisedStates.length; i++){
            let initState = initData.initialisedStates[i];
            initState = Object.assign({},initState,{
                message: strings[initState.localeStringConstant]
            });
            initStates = dataHelper.immutablePush(initStates,initState);
        }

        initData = Object.assign({},initData,{
            initialisedStates: Object.assign([],initStates),
            mainMessage: strings[initData.localeStringConstant]
        });

        let updatedInitData = Object.assign({}, appHelper.updateInitDataState(initData, constant));
        this.props.actions.updateInitData(updatedInitData);

        //this.setState({initData: Object.assign({}, updatedInitData)});
    }

    getInitStateByContsant(constant) {
        let tempData = Object.assign({}, this.props.initData);
        return appHelper.getInitStateByConstant(tempData.initialisedStates, constant);
    }

    onImageLoaded(event) {
        this.loadedImages = this.loadedImages + 1;
        if (this.loadedImages.length === this.state.imagesToLoad.length) {
            this.imagesLoaded = true;
            let checkInitialised = this.checkInitialised;
            setTimeout(function () {
                checkInitialised();
            }, 2000);
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        let initData = this.state.initData;
        let trackingData = this.props.trackingData;
        let Dialog = this.props.dialogPopup.component;
        return (
            <div className="screen guroo" ref="screen" role="alert" aria-busy="true">

                <Preloader/>


                {!initData.initialised && this.state.imagesToLoad.length > 0
                    ?
                    <div
                        className={this.state.env.window.size === 'xs' ? 'abs-centered-panel-sml-mobile' : 'abs-centered-panel-sml'}>

                        <span>
                        <p>{initData.mainMessage}</p>
                            {initData.initialisedStates.map(state =>
                                state.constant === initData.currentState
                                    ? <p key={state.constant}>{state.message}</p>
                                    : null
                            )}
                            </span>
                    </div>
                    :
                    <div
                        className={this.state.env.window.size === 'xs' ? 'abs-centered-panel-sml-mobile' : 'abs-centered-panel-sml'}>
                        <span><p>{appHelper.getLocaleString("welcome_label")} {trackingData.first_name.includes('Guest') ? "" : `${trackingData.first_name} ${trackingData.last_name}`}</p></span>
                    </div>
                }
                {this.state.imagesReadyToPreload && this.state.imagesToLoad.length > 0
                    ? this.state.imagesToLoad.map(image =>
                        <div key={image} className="preloading-image" ref={image}>

                            <img src={this.getImagePath(image)} name={image} value={image} onLoad={this.onImageLoaded}
                                 alt=""
                                 onError={this.onImageNotLoaded}/>
                        </div>
                    )
                    : null
                }
                {this.state.dialogPopup.render
                    ? <Dialog/>
                    : null
                }
            </div>
        );
    }
}

Initialisation.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

Initialisation.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
        dialogPopup: state.dialogPopup,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions, userDataActions, appDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Initialisation);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/Initialisation.js
 **/